import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, ResourcesApi } from '@shared/api';
import { FileUtils } from '@shared';

interface IDownloadResourceStore {
  loading: boolean;
  error: string | null;
  downloadResource: (params: { id: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadResourceStore = create<IDownloadResourceStore>((set) => ({
  loading: false,
  error: null,

  downloadResource: ApiUtils.wrapperApi(async (params: { id: string; filename: string }, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ResourcesApi.downloadFile(params.id, signal);
      FileUtils.downloadFile(result.data, params.filename);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
